import { get,post } from "@/axios/http";
/** 变异详情页接口 */
const zxIndex = data => post('/consult/page',data);
const zxDetail = data => get('/consult/getDetail',data);
const tagData = data => post('/consult/pageTag',data);


export {
    zxIndex,
    tagData,
    zxDetail
}